export type CanvasProps = {
  display: boolean;
  frameOptions: any;
  paperOptions: {
    border: boolean;
    borderColor: string;
    mirrored: boolean;
    type: string;
  };
  treatmentOptions: {
    subcategory: string;
    type: string;
  };
};

export const canvasProps: CanvasProps = {
  display: false,
  frameOptions: {
    dimensions: {
      depth: 1.125,
      face: 0.75,
    },
    label: "White Gallery Frame",
    texture: {
      face: "white",
      hex: "#fffffe",
      preview: "white",
      side: "white",
    },
    type: "",
  },
  paperOptions: {
    border: false,
    borderColor: "#fff",
    mirrored: false,
    type: "Exhibition Matte Canvas",
  },
  treatmentOptions: {
    subcategory: "",
    type: "Canvas on Stretcher",
  },
};
